import React from 'react';
import PropTypes from 'prop-types';

import FilesGrid from '../../../Files/Grid';
import FilesMasonry from '../../../Files/Masonry';
import FilesTile from '../../../Files/Tile';

export const FeedGrid = ({
  files,
  columns,
  renderDisplayAction,
  selectedView,
}) => {
  const safeColumns = Math.min(Math.max(columns || 3, 1), 6);

  return (
    <div className="widget-files-big-list puck-feed-grid-wrapper">
      <FilesGrid
        files={files}
        canDrag={false}
        allowCheck={true}
        displayOnly={true}
        renderDisplayAction={renderDisplayAction}
        className={`puck-feed-system-grid puck-feed-system-grid--cols-${safeColumns}`}
        selectedView={selectedView}
      />
    </div>
  );
};

FeedGrid.propTypes = {
  files: PropTypes.array.isRequired,
  columns: PropTypes.number,
  renderDisplayAction: PropTypes.func,
  selectedView: PropTypes.string,
};

FeedGrid.defaultProps = {
  columns: 3,
  renderDisplayAction: null,
  selectedView: null,
};

export const FeedMasonry = ({ files, renderDisplayAction }) => (
  <FilesMasonry
    files={files}
    displayOnly={true}
    allowCheck={true}
    renderDisplayAction={renderDisplayAction}
  />
);

FeedMasonry.propTypes = {
  files: PropTypes.array.isRequired,
  renderDisplayAction: PropTypes.func,
};

FeedMasonry.defaultProps = {
  renderDisplayAction: null,
};

export const FeedTile = ({
  files,
  renderDisplayAction,
  overwriteUrl,
}) => (
  <FilesTile
    files={files}
    displayOnly={true}
    allowCheck={true}
    disableRowConstraints={true}
    renderDisplayAction={renderDisplayAction}
    overwriteUrl={overwriteUrl}
  />
);

FeedTile.propTypes = {
  files: PropTypes.array.isRequired,
  renderDisplayAction: PropTypes.func,
  overwriteUrl: PropTypes.func,
};

FeedTile.defaultProps = {
  renderDisplayAction: null,
  overwriteUrl: null,
};
